import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {AutonomyUsageLessonsLink, CommunityUsageLessonsLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {ToolsGroup} from './tools.group';

export const TeachGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    label: 'navigation.teach',
    links: [
        CommunityUsageLessonsLink(context),
        AutonomyUsageLessonsLink(context),
        ToolsGroup(context)
    ]
});